// show menu
window.showMenu = () => {
    var hamburger = document.querySelector('.hamburger');
    var menu = document.querySelector('.menu');
    hamburger.classList.toggle('is-active');
    menu.classList.toggle('is-active');
};
